export default __webpack_public_path__ + "static/media/prev-clicked.7361dbd3.svg";